<div class="company-block" *ngIf="visible">
  <div class="company-menu">
    <div class="menu-left">Peergroup Comparison</div>
  </div>
  <div
    class="company-treemap"
    *ngIf="iready['Peergroup Comparison'] === true; else loadingPeergroup"
  >
    <ng-container
      *ngIf="
        !['industry', 'supersector', 'sector', 'subsector'].includes(
          qparam.type
        )
      "
    >
      <ng-container *ngIf="this.customScore === 'sentiment'">
        <div
          class="treemap-item"
          [class.mobile]="(screenSize$ | async)?.isMobile"
          *ngFor="
            let item of peergroup
              | orderBy: '-count'
              | slice: 0 : 7
              | orderBy: '-sentiment'
          "
        >
          <div
            class="item-cont peergroup"
            (click)="iEntity(item.entity.type, item.entity.alpha_id)"
          >
            <div class="item-left peergroup">
              <div>{{ item.entity.name }}</div>
            </div>
            <div class="item-rigt">
              <div [style.color]="item.sentiment | color">
                {{ item.sentiment | percent }}
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="this.customScore !== 'sentiment'">
        <div
          class="treemap-item"
          [class.mobile]="(screenSize$ | async)?.isMobile"
          *ngFor="
            let item of peergroup
              | orderBy: '-count'
              | slice: 0 : 7
              | orderBy: '-score'
          "
        >
          <div
            class="item-cont peergroup"
            (click)="iEntity(item.entity.type, item.entity.alpha_id)"
          >
            <div class="item-left peergroup">
              <div>{{ item.entity.name }}</div>
            </div>
            <div class="item-rigt">
              <div
                [style.color]="
                  getScoreType() === 'pos'
                    ? (item.score | colorScore2)
                    : (item.score | colorScore)
                "
              >
                {{ item.score }}
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-container
      *ngIf="
        ['industry', 'supersector', 'sector', 'subsector'].includes(qparam.type)
      "
    >
      <div
        class="treemap-item"
        [class.mobile]="(screenSize$ | async)?.isMobile"
        *ngFor="
          let item of peergroup | orderBy: '-count' | orderBy: '-sentiment'
        "
      >
        <div
          class="item-cont peergroup"
          (click)="iEntity(item.entity.type, item.entity.alpha_id)"
        >
          <div class="item-left peergroup">
            <div>{{ item.entity.name }}</div>
          </div>
          <div class="item-rigt">
            <div [style.color]="item.sentiment | color">
              {{ item.sentiment | percent }}
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <ng-template #loadingPeergroup>
    <div
      class="loading"
      *ngIf="
        loading['Peergroup Comparison'] &&
        !(iready['Peergroup Comparison'] === null)
      "
    >
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
    <div class="nodata" *ngIf="nodata['Peergroup Comparison']">
      NO DATA AVAILABLE
    </div>
    <div class="nodata" *ngIf="iready['Peergroup Comparison'] === null">
      NO DIRECT PEERGROUP IDENTIFIED
    </div>
  </ng-template>
</div>
